<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path
            d="M 22.863 11.5 C 23.046 11.844 23.046 12.156 22.863 12.5 L 18.111 21.5 C 17.928 21.844 17.525 22 17.16 22 L 6.739 22 C 6.374 22 6.038 21.788 5.855 21.444 L 1.137 12.556 C 0.954 12.212 0.954 11.788 1.137 11.444 L 5.854 2.556 C 6.037 2.212 6.374 2 6.739 2 L 17.16 2 C 17.524 2 17.928 2.157 18.111 2.5 Z M 8 12 C 8 14.209 9.791 16 12 16 C 14.209 16 16 14.209 16 12 C 16 9.791 14.209 8 12 8 C 9.791 8 8 9.791 8 12 Z"
        />
    </svg>
</template>
